
import { Location } from 'react-router-dom';

export const assetPaths = {
  root: 'assets',
};

const activitiesOrAssetPageRegex = /\/activities(\/|$)|\/assets(\/|$)/;

export function isActivityOrEditPage(location: Location<any>): boolean {
  return (
    location.pathname.includes('/activity/') ||
    location.pathname.includes('/edit') ||
    location.pathname.includes('/detail') ||
    location.pathname.includes('/routines') ||
    location.pathname.includes('/files')
  );
}

export function isFromActivitiesOrAssetPage(document: Document): boolean {
  const documentReferrer = typeof document !== 'undefined' ? document.referrer : '';
  return activitiesOrAssetPageRegex.test(documentReferrer);
}